<app-categories-and-tags
  *ngFor="let tag of tags"
  [tag]="tag"
  [isSelected]="isTagSelected(tag)"
  [isAddCustomTag]="false"
  (click)="onTagClicked(tag)"
  [classList]="classList"
></app-categories-and-tags>
<app-categories-and-tags
  *ngIf="showAddCustomTag"
  [isAddCustomTag]="true"
  (click)="onTagClicked(null)"
></app-categories-and-tags>
